import React from 'react';

const modules = [
  {
    icon: 'dashboard',
    iconColor: 'text-blue-900',
    lightBg: 'bg-blue-50',
    title: 'Controle Operacional',
    description: 'Gerencie processos, defina fluxos e atribua responsabilidades por setor.',
    features: ['Controle de processos', 'Definição de fluxo operacional', 'Setores e responsáveis'],
  },
  {
    icon: 'location_on',
    iconColor: 'text-orange-600',
    lightBg: 'bg-orange-50',
    title: 'Requisição do Cidadão',
    description: 'Canal direto entre o cidadão e o poder público com rastreamento em tempo real.',
    features: ['Requerimento com geolocalização', 'Painel de requisições', 'Demandas de comunidades'],
  },
  {
    icon: 'assignment',
    iconColor: 'text-blue-900',
    lightBg: 'bg-blue-50',
    title: 'Gestão de Projetos',
    description: 'Planeje, acompanhe e entregue projetos estratégicos com indicadores de resultado.',
    features: ['Planejamento Estratégico (KPI/OKR)', 'Projetos com Plano de ação', 'Controle de produtividade', 'Painel de indicadores'],
  },
];

const differentials = [
  { icon: 'sync', color: 'text-orange-600 bg-orange-50 border-gray-200', title: 'Integração SEI!', description: 'Conectividade nativa com o SEI! e demais APIs.' },
  { icon: 'build', color: 'text-blue-900 bg-blue-50 border-gray-200', title: 'Automação Inteligente', description: 'Automatização de tarefas repetitivas e fluxos de trabalho complexos.' },
  { icon: 'access_time', color: 'text-orange-600 bg-orange-50 border-gray-200', title: 'Tempo Real', description: 'Monitoramento de processos, setores e projetos em tempo real.' },
  { icon: 'touch_app', color: 'text-blue-900 bg-blue-50 border-gray-200', title: 'Interface Amigável', description: 'Design intuitivo que facilita a adoção por todos os usuários.' },
];

const ModulesSection = () => (
  <section id="modulos" className="py-24 bg-gray-50">
    <div className="container mx-auto px-6 md:px-12">
      <div className="text-center mb-16">
        <div className="inline-flex items-center gap-2.5 mb-4 justify-center">
          <span className="w-1 h-4 bg-blue-900" />
          <span className="text-xs font-bold uppercase tracking-widest text-blue-900">
            Módulos
          </span>
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 tracking-tight">
          Uma plataforma, três módulos poderosos
        </h2>
        <p className="text-gray-500 max-w-xl mx-auto text-base">
          Plataforma modular com planos escaláveis a partir de 100 usuários.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-20">
        {modules.map((mod, idx) => (
          <div
            key={idx}
            className="bg-white rounded-xl overflow-hidden border border-gray-200 hover:shadow-md transition-all duration-200 group flex flex-col"
          >
            <div className={`${mod.lightBg} px-6 pt-6 pb-4`}>
              <div className="inline-flex p-3 rounded-lg bg-white border border-gray-100 shadow-sm mb-4">
                <span className={`material-icons text-3xl ${mod.iconColor}`}>{mod.icon}</span>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-1">{mod.title}</h3>
              <p className="text-sm text-gray-500 leading-relaxed">{mod.description}</p>
            </div>
            <div className="px-6 py-5 flex-1">
              <ul className="space-y-2.5">
                {mod.features.map((feat, i) => (
                  <li key={i} className="flex items-center gap-2.5 text-gray-700 text-sm">
                    <div className="w-5 h-5 rounded-md bg-blue-50 flex items-center justify-center flex-shrink-0">
                      <svg className="w-3 h-3 text-blue-900" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                    </div>
                    {feat}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>

      {/* Differentials */}
      <div className="text-center mb-10">
        <h3 className="text-2xl font-bold text-gray-900">Nossos Diferenciais</h3>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {differentials.map((d, idx) => {
          const [textCls, bgCls, borderCls] = d.color.split(' ');
          return (
            <div
              key={idx}
              className={`${bgCls} border ${borderCls} rounded-xl p-6 text-center hover:shadow-sm transition-all duration-200`}
            >
              <div className="inline-flex p-3 rounded-lg bg-white shadow-sm mb-4">
                <span className={`material-icons text-2xl ${textCls}`}>{d.icon}</span>
              </div>
              <h4 className="text-sm font-bold text-gray-900 mb-2">{d.title}</h4>
              <p className="text-gray-500 text-xs leading-relaxed">{d.description}</p>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);

export default ModulesSection;
